module.exports = __webpack_public_path__ + "static/img/f3.11bf8ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f3.png
// module id = MIQq
// module chunks = 1